<template>
  <div>
    <b-collapse id="filter-pane-collapse" @hidden="emitReloadData" class="m-2">
      <div :style="style" class="border bg-white">
        <b-card class="border-0">
          <div>
            <div class="d-flex align-items-center">
              <div class="ml-auto">
                <b-button variant="info"
                          v-b-toggle.filter-pane-collapse>
                  Filtrar
                </b-button>
                <b-button variant="warning"
                          @click="resetFilters">
                  Limpiar Filtros
                </b-button>
              </div>
            </div>
          </div>
          <b-container fluid class="m-0">
            <b-row>
              <b-col sm="6">
                <FilterSelectorLogic :filter-data="originalProductFilters"
                                     filter-type="product_filters"
                                     filter-type-name="Filtro atributos de productos"
                                     ref="filterSelectorLogicP"/>
              </b-col>
              <b-col sm="6">
                <FilterSelectorLogic :filter-data="originalStoreFilters"
                                     filter-type="store_filters"
                                     filter-type-name="Filtro de Tiendas"
                                     ref="filterSelectorLogicS"/>
              </b-col>
            </b-row>
          </b-container>
          <div style="height: 10px;"></div>
        </b-card>
      </div>
    </b-collapse>
  </div>
</template>

<script>
  // *****************************************************************************************************************
  //                                                  IMPORTS
  // *****************************************************************************************************************
  import { FilterObjectParameterBuilder, GeneralUtils } from '@/mixins/index'
  import FilterSelectorLogic from './FilterSelectorLogic'
  export default {
    name: '',
    // *****************************************************************************************************************
    //                                                 MIXINS
    // *****************************************************************************************************************
    mixins: [FilterObjectParameterBuilder, GeneralUtils],
    // *****************************************************************************************************************
    //                                                  PROPS
    // *****************************************************************************************************************
    props: {
      height: {
        default: 100
      }
    },
    // *****************************************************************************************************************
    //                                                  COMPONENTS
    // *****************************************************************************************************************
    components: {
      FilterSelectorLogic
    },
    data () {
      return {
        style: null
      }
    },
    // *****************************************************************************************************************
    //                                                HOOKS
    // *****************************************************************************************************************
    created () {
    },
    mounted () {
      let val = this.height
      this.style = `overflow: auto; height: ${val}px`
    },
    computed: {
      originalProductFilters () {
        return this.$_generalUtils_deepJsonCopy(this.$store.getters.productCategoryFilters)
      },
      originalStoreFilters () {
        return this.$_generalUtils_deepJsonCopy(this.$store.getters.storeFilters)
      }
    },
    // *****************************************************************************************************************
    //                                                METHODS
    // *****************************************************************************************************************
    methods: {
      emitReloadData () {
        this.$eventHub.$emit('filter-pane-filter-update')
        this.$emit('filter-pane-updated')
      },
      resetFilters () {
        this.$refs.filterSelectorLogicP.reset()
        this.$refs.filterSelectorLogicS.reset()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/expertoRetail/components/FilterPane/FilterPane.vue